import React from 'react';
import {connect} from "react-redux";
import * as actionCreators from "../../actions/actionCreators"
import Journey from "../../component/audit/journey.js";
import moment from 'moment';

import 'moment/locale/fr';
moment.locale('fr');

class Journeycon extends React.Component{
  constructor(props) {
        super(props);

        this.handleHotelsChange = this.handleHotelsChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.onChangeDateRange = this.onChangeDateRange.bind(this);
        this.calculateDistance = this.calculateDistance.bind(this);
        this.exportDistancesToJson = this.exportDistancesToJson.bind(this);
        this.handleStartEndChange = this.handleStartEndChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);

        this.state = {
            steps: [],
            distances: [],
            travelMode: "Driving",
            dateStart: moment().startOf('day').subtract(1, 'months'),
            dateEnd: moment().endOf('day'),
            dataLoaded: false,
            calculating: 0,
            startEnd: false,
        }

  }

    handleDateChange(date, index){
        let steps = this.state.steps;
        steps[index].value.date = date.format();
        console.log(steps[index])
        this.setState({ steps }, () => {
            this.calculateDistance();
        });
    };

    handleStartEndChange(event){
        this.setState({ startEnd: event.target.checked }, () => {
            this.mergeData();
        });
    }

    onChangeDateRange(dateStart, dateEnd) {
        this.setState({dateStart: dateStart, dateEnd: dateEnd.endOf('day')}, () => {
            this.mergeData();
        })
    }

    searchDirection(start, end, delay){
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                const DirectionsService = new window.google.maps.DirectionsService();

                DirectionsService.route({
                    origin: start,
                    destination: end,
                    travelMode: window.google.maps.TravelMode.DRIVING,
                    provideRouteAlternatives: false,
                }, (result, status) => {
                    if (status === window.google.maps.DirectionsStatus.OK) {
                        resolve(result);
                    } else {
                        reject(status);
                    }
                });
            }, delay)
        });
    }

    componentWillMount() {
        /* import les audits */
        if(!this.state.dataLoaded) {
            this.props.getAuditsAction().then(res => {
                /* import les archives */
                this.props.getArchivesAction().then(res2 => {
                        this.mergeData();
                })
            })
        }

    }

    mergeData(){
        let audits = (!this.state.dateStart || !this.state.dateEnd) ? [...this.props.archives, ...this.props.audits] : [...this.props.archives, ...this.props.audits].sort(function(a,b){
            return moment(a.date) - moment(b.date);
        }).filter(audit => (audit.status !== "waiting" && audit.status !== "appointment_notified" && moment(audit.date).isSameOrAfter(this.state.dateStart) && moment(audit.date).isSameOrBefore(this.state.dateEnd)));
        if(audits.length > 0){
            let steps = [];
            // Si on ajoute le début et la fin du parcours
            if(this.state.startEnd) {
                steps.push({type: "start",
                    value: {
                        address: "35 Rue des Chantiers, Versailles, France",
                        date:moment(audits[0].date).subtract(1,"days"),
                        longitude: 2.138662599999975,
                        latitude: 48.795951
                    }
                });
                steps.push({type: "hotel",
                    value: {
                        address: "35 Rue des Chantiers, Versailles, France",
                        date: moment(audits[0].date).subtract(1,"days").add(1, "hours").endOf('day'),
                        period: "evening",
                        longitude: 2.138662599999975,
                        latitude: 48.795951
                    }
                });
            }
            steps.push({type: "hotel", value: {address: "35 Rue des Chantiers, Versailles, France", date: moment(audits[0].date).add(1, "hours"), period: "morning", longitude: 2.138662599999975 , latitude: 48.795951}});
            for (var i = 0; i < audits.length; i ++){
                let audit = audits[i];
                let diff_days = 0;
                let prev_audit = audit;
                if(i > 0){
                    prev_audit = audits[i - 1];
                    if(moment(audit.date).isSame(moment(prev_audit.date), 'day')){
                        diff_days = 0;
                    }else{
                        diff_days = moment(audit.date).startOf('day').diff(moment(prev_audit.date).startOf('day'), 'days');
                        //console.log(diff_days + " => " + audit.company.name + " : " + moment(audit.date).format()+ " " + moment(prev_audit.date).format());
                        steps.push({type: "hotel", value: {address: "35 Rue des Chantiers, Versailles, France", date: moment(prev_audit.date).add(1, "hours"), period: "evening", longitude: 2.138662599999975 , latitude: 48.795951}});
                        if(diff_days > 1){ // si > 1 alors on ajoute un novueau point de départ qui peut être différent du point d'arriver
                            steps.push({type: "hotel", value: {address: "35 Rue des Chantiers, Versailles, France", date: moment(audit.date).add(1, "hours"), period: "morning", longitude: 2.138662599999975, latitude: 48.795951}});
                        }
                    }
                }
                steps.push({type: "audit", value: audit});
            };
            steps.push({type: "hotel", value: {address: "35 Rue des Chantiers, Versailles, France", date: moment(audits[audits.length - 1].date).add(1, "hours"), period: "evening", longitude: 2.138662599999975, latitude: 48.795951}});
            // Si on ajoute le début et la fin du parcours
            if(this.state.startEnd) {
                steps.push({type: "hotel",
                    value: {
                        address: "35 Rue des Chantiers, Versailles, France",
                        date: moment(audits[audits.length - 1].date).add(1, "days").add(1, "hours").startOf('day'),
                        period: "morning",
                        longitude: 2.138662599999975,
                        latitude: 48.795951
                    }
                });

                steps.push({type: "end",
                    value: {
                        address: "35 Rue des Chantiers, Versailles, France",
                        date: moment(audits[audits.length - 1].date).add(1, "days"),
                        longitude: 2.138662599999975,
                        latitude: 48.795951
                    }
                });
            }
            this.setState({
                steps: steps,
                distances: [],
                dataLoaded: true
            })
        }else{
            this.setState({
                steps: [],
                distances: [],
                dataLoaded: true
            })
        }
    }

    handleHotelsChange(event, index){
        let steps = this.state.steps.slice()
        let hotel = Object.assign({}, steps[index]);
        hotel.value.longitude = event.target.longitude;
        hotel.value.latitude = event.target.latitude;
        hotel.value.address = event.target.address;

        steps[index] = hotel;
        this.setState({steps: steps, distances: []})
    }

    calculateDistance(){
      let steps = this.state.steps;
      if(steps.filter(step => step.value.address === "").length === 0){

          this.setState({calculating: 1, dataLoaded: true}, async() => {
              let distances = [];
              for (var i = 1; i < steps.length; i++){
                  let max_try = 5;
                  let delay = 200;
                  let status = null;
                  do {
                      if(steps[i-1].type === "hotel" && steps[i].type === "hotel") {
                          status = null;
                          distances.push({distance: {text: "", value: 0}, path:null, start: null, end: null});
                      }else{
                          try {
                              let res = await this.searchDirection(
                                  new window.google.maps.LatLng(steps[i - 1].value.latitude, steps[i - 1].value.longitude),
                                  new window.google.maps.LatLng(steps[i].value.latitude, steps[i].value.longitude),
                                  delay
                              );

                              status = null;
                              let val = Object.assign({}, res.routes[0].legs[0]);
                              val.path = res.routes[0].overview_polyline
                              val.start = steps[i - 1].value.address;
                              val.end = steps[i].value.address;
                              val.date = steps[i].value.date;
                              if(steps[i-1].type === "start" || steps[i-1].type === "end"){
                                  val.date = moment(steps[i-1].value.date).subtract((res.routes[0].legs[0].duration.value), 'seconds').format();
                              }else if(steps[i].type === "hotel"){
                                  val.date = moment(steps[i].value.date).add(res.routes[0].legs[0].duration.value, "seconds");
                              }
                              distances.push(val);
                          } catch(err) {
                              status = err;
                              delay = 3000;
                          }
                      }
                      max_try--;
                  }while(status === "OVER_QUERY_LIMIT" && max_try > 0);
                  if(max_try === 0){
                      this.props.displaySnackbar("error", "Erreur de calcul, veuillez rééssayer...");
                      break;
                  }
                  this.setState({calculating: (i * 100) / (steps.length)});
              };

              this.setState({calculating: 0, distances:distances, dataLoaded: true});

          });
      }
    }

    handleFormSubmit(){
        //
    }

    exportDistancesToJson(){
        let distances = this.state.distances;
        if(distances.length > 0){
            let data = [];
            for (let i = 0; i < distances.length; i++){
                let distance = distances[i];
                if(distance.path){
                    data.push({
                        "description": "Déplacement",
                        "from": distance.start,
                        "to": distance.end,
                        "date": moment(distance.date).subtract((distance.duration.value + 600), 'seconds').format(),
                        "audit_date": moment(distance.date).format(),
                        "distance": distance.distance.value + 1,
                    });
                }
            }
            console.log(data);

            let filename = "export.json";
            let contentType = "application/json;charset=utf-8;";
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                var blob = new Blob([decodeURIComponent(encodeURI(JSON.stringify(data)))], { type: contentType });
                navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                var a = document.createElement('a');
                a.download = filename;
                a.href = 'data:' + contentType + ',' + encodeURIComponent(JSON.stringify(data));
                a.target = '_blank';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        }
    }

  render(){
    return <Journey
        handleDateChange={this.handleDateChange}
        startEnd={this.state.startEnd}
        handleStartEndChange={this.handleStartEndChange}
        exportDistancesToJson={this.exportDistancesToJson}
        distances={this.state.distances}
        calculating={this.state.calculating}
        calculateDistance={this.calculateDistance}
        dataLoaded={this.state.dataLoaded}
        onChangeDateRange={this.onChangeDateRange}
        user={this.props.user}
        handleFormSubmit={this.handleFormSubmit}
        handleHotelsChange={this.handleHotelsChange}
        dateStart={this.state.dateStart}
        dateEnd={this.state.dateEnd}
        steps={this.state.steps}
    ></Journey>
  }
}

const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(Journeycon);



// WEBPACK FOOTER //
// ./src/container/audit/journey-container.js